import React from 'react';

import { Button, Group, Title, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons-react';
import PageHeader from 'components/PageHeader';
import { useAuth } from 'context/auth-context';

import ClassTypeTableContainer from './components/ClassTypeTableConatiner';
import DrawerClassTypeForm from './components/DrawerClassTypeForm';

const ClassType = (): JSX.Element => {
  const theme = useMantineTheme();
  const { hasPerm } = useAuth();
  const classPerm = hasPerm('EventTypeLocationMutate');
  const [createFormOpened, { open: openCreateForm, close: closeCreateForm }] = useDisclosure(false);

  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Title order={1} size='h1'>
            Class Type
          </Title>
          <Button
            leftIcon={<IconPlus size={theme.fontSizes.md} />}
            onClick={openCreateForm}
            disabled={!classPerm}
            data-cy='createClassButton'
          >
            Class Type
          </Button>
        </Group>
      </PageHeader>

      <ClassTypeTableContainer permission={classPerm} />

      <DrawerClassTypeForm
        formId='create-kilo-class-type-form'
        title={<Title order={3}>Create Class Type</Title>}
        opened={createFormOpened}
        closeHandler={closeCreateForm}
        type='create'
      />
    </>
  );
};

export default ClassType;
